import React from 'react';
import { useTranslation } from 'react-i18next';

import * as router from '@configs/routes.json';

import './DownloadPackageBtn.scss';

interface DownloadPackageBtnProps {
  isDisabled: boolean;
  packageId: string;
  projectId: string;
}

const DownloadPackageBtn: React.FC<DownloadPackageBtnProps> = ({
  isDisabled,
  packageId,
  projectId,
}) => {
  const { t } = useTranslation();
  return (
    <a
      className={`btn btn-primary download-btn ${isDisabled ? 'disabled' : ''}`}
      role='button'
      href={`${router.api.reports.downloadPackage.replace(
        ':id',
        packageId
      )}?projectid=${encodeURIComponent(projectId)}`}
      download
    >
      <i className='fas fa-cloud-download-alt mx-1'></i>
      {t('downloadResultsPkg_downloadButton').toUpperCase()}
    </a>
  );
};

export default DownloadPackageBtn;
